var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Navbar'),_c('Alert'),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('Sidebar'),_c('main',{staticClass:"col-md-9 ml-sm-auto col-lg-10 px-md-4",attrs:{"role":"main"}},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }